const initState = {
  generatePaymentButton: {
    success: null,
    error: null,
    code: null,
    message: null,
    token: null,
    url: null,
  },
  confirmPaymentButton: {
    success: null,
    error: null,
    code: null,
    message: null,
    paymentType: null,
    authorizationCode: null,
    cardNumber: null,
    transactionDate: null,
  },
};

export default initState;
